/**
 * Feature Flags Configuration
 * Epic 23: Professional Homepage Transformation
 */

export const FEATURES = {
  /**
   * Professional Homepage - Epic 23
   * When true: Renders professional card-based agent gallery
   * When false: Renders original table-based view (Epic 20)
   * 
   * Rollback: Set to false to instantly revert to table view
   */
  PROFESSIONAL_HOMEPAGE: import.meta.env.VITE_PROFESSIONAL_HOMEPAGE === 'true',
  
  /**
   * Side Panels - Epic 23 Phase 2
   * When true: Shows left (progress) and right (metrics) panels
   * When false: Main content only (original layout)
   */
  SIDE_PANELS: import.meta.env.VITE_SIDE_PANELS === 'true',
  
  /**
   * Epic 8 Walkthrough System
   * When true: Progressive walkthrough framework enabled
   * When false: No guided tours (instant rollback)
   * 
   * Controls: WalkthroughProvider, WalkthroughOverlay, Demo Controller
   */
  EPIC_8_WALKTHROUGH: import.meta.env.VITE_EPIC_8_WALKTHROUGH === 'true',
  
  /**
   * Demo Mode - Purple 🎬 Button
   * When true: Shows investor presentation controls
   * When false: Hidden (normal user experience)
   */
  DEMO_MODE: import.meta.env.VITE_DEMO_MODE === 'true',
  
  /**
   * Step 5 User Prompting - Advanced Challenge Guidance
   * 
   * Allows users to provide natural language guidance for LLM challenge generation.
   * 
   * Safety: Already implemented with validation, optional field, graceful fallbacks.
   * Enable: localStorage.setItem('enable_step5_prompting', 'true')
   * Disable: localStorage.removeItem('enable_step5_prompting')
   */
  STEP5_USER_PROMPTING: (() => {
    try {
      return typeof window !== 'undefined' && 
             process.env.NODE_ENV === 'development' && 
             localStorage.getItem('enable_step5_prompting') === 'true';
    } catch {
      return false; // SSR safe
    }
  })(),
} as const;

/**
 * Feature flag helpers
 */
export const enableFeature = {
  step5Prompting: () => {
    localStorage.setItem('enable_step5_prompting', 'true');
    console.log('🎯 Step 5 User Prompting ENABLED! Refresh the page to see the advanced guidance textarea.');
  }
};

export const disableFeature = {
  step5Prompting: () => {
    localStorage.removeItem('enable_step5_prompting');
    console.log('🔒 Step 5 User Prompting disabled. Refresh the page to hide advanced options.');
  }
};

// Global console helpers (development only)
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  (window as any).enableStep5Prompting = () => {
    localStorage.setItem('enable_step5_prompting', 'true');
    console.log('🎯 Step 5 User Prompting ENABLED! Refreshing page...');
    window.location.reload();
  };
  
  (window as any).disableStep5Prompting = () => {
    localStorage.removeItem('enable_step5_prompting');
    console.log('🔒 Step 5 User Prompting disabled. Refreshing page...');
    window.location.reload();
  };
  
  (window as any).checkStep5Prompting = () => {
    const enabled = localStorage.getItem('enable_step5_prompting') === 'true';
    console.log(`Step 5 User Prompting: ${enabled ? '✅ ENABLED' : '❌ DISABLED'}`);
    return enabled;
  };
}
